export const AGORA_APP_ID = 'c902493ba1624bce84860a7028761f3d'
